import {
  makeObservable,
  observable,
  computed,
  action,
  runInAction
} from 'mobx';

class CustomDrawerViewModel {
  @observable isOpen = false;

  constructor(props) {
    makeObservable(this);
  }

  @action open = () => {
    this.isOpen = true;
  };

  @action close = () => {
    this.isOpen = false;
  };
}

export default CustomDrawerViewModel;
